<template>
  <Toaster />
  <HoldReasonModal />
  <component :is="layout">
    <RouterView v-slot="{ Component }">
      <KeepAlive :include="['Customers']">
        <component :is="Component" />
      </KeepAlive>
    </RouterView>
  </component>
</template>

<script setup lang="ts">
import './assets/index.css'
import { useLogto } from '@logto/vue'
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import HoldReasonModal from '@/components/HoldReasonModal.vue'
import Toaster from '@/foundation/toast/Toaster.vue'
import { setLogtoInstance } from './composables/src/useLogTo.ts'

const logto = useLogto()

const route = useRoute()
const layout = computed(() => `layout-${route.meta.layout || 'login'}`)

onMounted(() => {
  setLogtoInstance(logto)
})
</script>
